<app-splash-screen (closeEmitter)="closeSplash()" *ngIf="splashVisible"></app-splash-screen>

<hot-table
  [colHeaders]="true"
  [rowHeaders]="true"
  autoWrapRow={true}
  autoWrapCol={true}
  licenseKey="non-commercial-and-evaluation">
</hot-table>